<template>
  <LayoutFullLogoDark />
</template>
